import { DomainError } from '../_kernel/DomainError'
import { ErrorsCode } from '../_kernel/ErrorsCode'

export type ReturnType<T> = [Error, undefined] | [undefined, T]

interface Options {
  required?: boolean
  caseSensitive?: boolean
}

const defaultOptions: Options = {
  required: true,
  caseSensitive: true,
}

function createCaseInsensitiveParams(originalParams: URLSearchParams): URLSearchParams {
  const newParams = new URLSearchParams()

  Array.from(originalParams.entries()).forEach(([key, value]) => {
    newParams.set(key.toLowerCase(), value)
  })

  return newParams
}
export abstract class QueryParams {
  abstract searchParams(): URLSearchParams

  getByQuery<T extends string>({
    query,
    options,
  }: {
    query: string
    options?: Options
  }): ReturnType<T> {
    const mergedOptions = { ...defaultOptions, ...options }

    let URLSearchParams = this.searchParams()
    let value = URLSearchParams.get(query)

    if (!mergedOptions.caseSensitive) {
      URLSearchParams = createCaseInsensitiveParams(URLSearchParams)
      value = URLSearchParams.get(query.toLowerCase())
    }

    if (mergedOptions.required && !value) {
      return [DomainError.withCodes(ErrorsCode.MISSING_QUERY_PARAM), undefined]
    }

    return [undefined, value as T]
  }
}
